import React, { Component } from 'react';
import Close from '@material-ui/icons/Close';
import PropTypes from 'prop-types';
import cogoToast from 'cogo-toast';
import cn from 'classnames';
import './UploadResults.scss';

import { deleteCall } from '../../api/calls';
import { uploadAudioFile } from '../../api/upload';
import { getPrettyTimeDisplayFromNumber, getPrettyFileSize } from '../../helpers/formatting';

const UploadResults = (props) => {
  const { uploads, setUploads } = props;
  return (
    <div className='upload-results'>
      {uploads.map((upload) => (
        <UploadResult key={upload.id} upload={upload} uploads={uploads} setUploads={setUploads} />
      ))}
    </div>
  );
};

UploadResults.propTypes = {
  uploads: PropTypes.array.isRequired,
  setUploads: PropTypes.func.isRequired,
};

class UploadResult extends Component {
  static propTypes = {
    uploads: PropTypes.array.isRequired,
    upload: PropTypes.object.isRequired,
    setUploads: PropTypes.func.isRequired,
  };

  state = {
    isUploading: false,
    isUploaded: false,
  };

  removeResult = () => {
    const { upload, uploads } = this.props;
    console.log(upload);
    if (upload.call) {
      deleteCall(upload.call)
        .then((resp) => {})
        .catch((error) => {
          cogoToast.error(`Had an issue deleting ${upload.file.name}.`);
        });
    }
    this.props.setUploads(uploads.filter((u) => u.id !== upload.id));
  };

  componentDidUpdate(prevProps) {
    const { upload } = this.props;
    const { isUploading, isUploaded } = this.state;
    const { signed_url, is_complete, file, duration_seconds } = upload;
    const { name, type } = file;

    const shouldStartUpload = is_complete && !isUploading && !isUploaded;
    if (shouldStartUpload) {
      this.setState({ isUploading: true });
      uploadAudioFile({
        chat_name: name,
        media_format: type,
        audio_only_s3_uri: `s3://${signed_url.split('.s3.amazonaws.com').join('').split('?')[0].split('//')[1]}`,
        num_chat_participants: 2,
        duration_seconds: duration_seconds,
      })
        .then((call) => {
          const { setUploads, uploads } = this.props;
          const newUploads = uploads.map((u) => (u.id === upload.id ? { ...u, call } : u));
          setUploads(newUploads);
        })
        .catch((err) => {
          console.error(err);
          cogoToast.warn(`Had an error uploading ${name}`);
        })
        .finally(() => {
          this.setState({ isUploadingCall: false, isUploaded: true });
        });
    }
  }

  render() {
    const { upload } = this.props;
    const { isUploaded } = this.state;
    const { progress, file, duration_seconds } = upload;
    const { name, type } = file;
    const progressWidth = 0.9 * progress + (isUploaded ? 10 : 0);
    return (
      <div key={upload.id} className='upload-result'>
        <div className='main'>
          <div className='name'>{name}</div>
          <div className='duration'>
            {type.toUpperCase()} • {getPrettyFileSize(file)} • {getPrettyTimeDisplayFromNumber(duration_seconds)}
          </div>
        </div>
        <div onClick={() => this.removeResult()} className='close-btn'>
          <Close />
        </div>
        <div className={cn('progress-bar', { complete: progressWidth === 100 })} style={{ width: `${progressWidth}%` }} />
        <div className='progress-bar-spine' />
      </div>
    );
  }
}

export default UploadResults;
